import styled from '@material-ui/styles/styled';
import { Banner } from '@vkontakte/vkui';
import { BannerProps } from '@vkontakte/vkui/dist/components/Banner/Banner';

export default styled(Banner)({
  '& .Banner__in:before, & .Banner__dismissIcon': {
    zIndex: 2,
  },
}) as React.FC<BannerProps>;
